const STATE = {
    OVERVIEW: "Overview",
    PACK: "Booster",
    SEALED: "Sealed",
    CART: "Cart",
    SINGLE: "Single",
    SUCCESS: "Success",
    PROMO: "Promotion",
    LOGIN: "Login",
    ACC_SETTINGS: "Account",
    SETTINGS: "Settings",
    PROFILE: "Profile",
};

const USER_TYPE = {
    EXISTING: "Existing",
    NEW: "New",
}

const STATES = ["VIC", "NSW", "WA", "QLD", "SA", "ACT","TAS",
];

const USERSTATES = { SIGN:"SIGN", REGISTER:"REGISTER", LOGIN:"LOGIN", LOGGED_IN:"LOGGED IN", PROFILE:"PROFILE", ORDERS:"ORDERS", SETTINGS: "SETTINGS"};

const PMT = {
    CARD:"CARD",
    PAYID:"PAYID"
};

export {USER_TYPE, STATE, STATES, PMT, USERSTATES};